module.exports = __webpack_public_path__ + "img/SpotifyAds.82a07222.svg";